<template lang="pug">
  .wrapper-verify-timesheet
    h2 verificar folhas

    .header-grid
      FixedArea
        template(v-slot:default="{fixed}")
          LineActions.line-actions(key="lineActions")

          .wrapper-verify-timesheet-header(v-show="!showLineActions", key="header")
            RadioSlider(
              :items="categories.items",
              :current="categories.items.findIndex(i => i.id === categories.selected.id)",
              @selected="openItemsSelector"
            )

            .items-selector
              PMultiSelect(
                ref="itemSelector"
                labelItem="name"
                :title="categorieSelected.name"
                :forcedPlaceholder="forcedPlaceholder"
                :useState="categorieSelected.useState"
                :useCommon="categorieSelected.common"
                :disabled="!categories.selected"
                @dblclick="ondblclick"
              )

            .start-date
              PDatePicker(
                name="date"
                label="inicio"
                useState="verifyTimesheet/startDate"
                format="DD/MM/YY"
              )

            .end-date
              PDatePicker(
                name="date"
                label="fim"
                useState="verifyTimesheet/endDate"
                format="DD/MM/YY"
              )

            .consult
              PButton(
                color="success"
                size="md"
                @click="doVerify(true, true)"
                block
                :disabled="!validForVerify"
              )
                | ok

            .verification
              TimesheetVerification(@doVerify="doVerify")

    .sheet.prevent-double-scroll
      Sheet(type="work-place", :startDate="startDate", :endDate="endDate", :verifyMode="true")

</template>

<script>
import { CompStoreModule } from 'src/common/mixins/abstractComponents'
import TimesheetVerification from './TimesheetVerification'
import Sheet from 'src/components/Sheets/Sheet/Sheet'
import { mapState } from 'vuex'
import FixedArea from 'src/common/FixedArea'
import LineActions from 'src/components/Sheets/Sheet/LineActions/LineActions'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  extends: CompStoreModule,
  storeModule: 'verifyTimesheet',
  mounted () {
    setAmplitudeEvent('lista verificar folha', {})
  },
  created () {
    this.categories.selected = this.categories.items[0]

    this.$store.commit('sheet/resetState')
    this.$store.dispatch('verifyTimesheet/getTotal')
  },
  data () {
    return {
      categories: {
        selected: null,
        items: [
          { name: this.$wp('companyShortName'), id: 'company', alias: 'work-place', common: 'companies/onlyActive', useState: 'verifyTimesheet/companies' },
          { name: this.$wp('employee'), id: 'employee', alias: 'employee', common: 'employees/onlyNotFired', useState: 'verifyTimesheet/employees' },
          { name: 'grupos', id: 'userGroup', alias: 'user-group', common: 'userGroups', useState: 'verifyTimesheet/userGroups' }
        ]
      }
    }
  },
  computed: {
    ...mapState(
      'verifyTimesheet',
      ['startDate', 'endDate', 'verificationKind', 'verificationFilters', 'employees', 'companies', 'userGroups']
    ),
    showLineActions () { return this.$store.state.sheet.lineActions.type !== null },
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 'company',
        alias: 'work-place',
        common: 'companies/onlyActive',
        useState: 'verifyTimesheet/companies'
      }
    },
    forcedPlaceholder () {
      const companies = this.companies.selected
      const employees = this.employees.selected
      const userGroups = this.userGroups.selected

      if (companies.length || employees.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar ' + this.$wp('companyShortName')
      } else if (this.categories.selected.id === 'employee') {
        return 'selecionar ' + this.$wp('employee')
      } else {
        return 'selecionar grupos'
      }
    },
    lastChanged () {
      return this.categories.selected.alias
    },
    validForVerify () {
      const pselectIsInvalid = !this.employees.selected.length && !this.companies.selected.length && !this.userGroups.selected.length
      const dateRangeIsInvalid = !this.startDate || !this.endDate

      if (pselectIsInvalid || dateRangeIsInvalid) {
        return false
      }
      return true
    }
  },
  methods: {
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    doVerify (fromStart = false, refreshTotal = false) {
      if (!this.validForVerify) return

      if (fromStart) {
        this.$store.commit('verifyTimesheet/verificationKind', 'doubleLines')
      }
      if (refreshTotal) {
        this.$store.dispatch('verifyTimesheet/getTotal', this.lastChanged)
      }
      this.$store.dispatch('verifyTimesheet/verifyTimesheet', this.lastChanged)
    },
    ondblclick (item) {
      this.$store.commit(
        this.categorieSelected.useState,
        {selected: [item]}
      )
      this.doVerify(false, true)
    }
  },
  components: { TimesheetVerification, Sheet, FixedArea, LineActions, RadioSlider }
}
</script>

<style scoped lang="scss">
.wrapper-verify-timesheet {
  height: 100%;
  display: grid;
  grid-template-rows: min-content min-content auto;
  grid-template-columns: 1fr;

  &.prevent-double-scroll {
    height: 100%;
    overflow-y: hidden;
  }

  h2 {
    text-align: center;
  }

  .sheet {
    width: 100%;
    height: 100%;
    text-align: center;
    grid-row: 3;
    padding-bottom: 10px;
  }
}
.selectors {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 10px;
}
.wrapper-verify-timesheet-header {
  display: grid;
  grid-template-columns: 400px 1fr 130px 130px 130px;
  grid-column-gap: 6px;
  grid-template-rows: auto;
  align-items: center;

  .verification {
    grid-column: 1 / 5;
  }
}
</style>
